import { FC } from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { useDebugMode } from '@app/providers/DebugModeProvider';

/**
 * Admin-screen switch for the `<DebugPanel>` dumps.
 *
 * Renders nothing outside a development build, so there is no way to turn debug
 * output on in staging or production.
 */
export const DebugModeToggle: FC = () => {
  const { enabled, available, setEnabled } = useDebugMode();

  if (!available) return null;

  return (
    <Box sx={{ padding: 2 }}>
      <FormControlLabel
        control={<Switch checked={enabled} onChange={(event) => setEnabled(event.target.checked)} />}
        label="Show debug panels"
      />
      <Typography variant="body2" color="text.secondary">
        Adds the raw object behind each screen to the page. Applies to your account on this browser only.
      </Typography>
    </Box>
  );
};
